import React, { useEffect, useRef, useState } from "react";
import { useAuth } from "../../../../context/AuthContext";
import { oneKlicks } from "../../../../SDK/oneclick";
import { OneKlicksFileSDK } from "../../../../SDK/OneKlicksFileSDK";
import { toast } from "react-toastify";
import { useParams, useNavigate } from "react-router-dom";
import PersonalDetails from "./PersonalDetails";
import CompanyProfile from "./CompanyProfile";
import Defaultlocation from "./Defaultlocation";
import Gallery from "./Gallery";
import DashBordmenu from "../../../../Uitiles/DashBordmenu";
import { getuserdata } from "../../../../services/apiService";

const defaultFormState = {
    gendar: "",
    subheading: "",
    display_name: "",
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    mobile_number: "",
    description: "",
    languages: [],
    address: "",
    city: "",
    state: "",
    country: "",
    postal_code: "",
    profile_photo_url: "",
};

const defaultCompanyState = {
    company_name: "",
    legal_name: "",
    email: "",
    phone: "",
    support_email: "",
    support_phone: "",
    website: "",
    registration_number: "",
    license_number: "",
    gst_number: "",
    address: "",
    city: "",
    state: "",
    country: "",
    postal_code: "",
    status: "active",
    notes: "",
};

const InsuranceProfileSettings = () => {
    const { userData } = useAuth();
    const { sublink } = useParams();
    const navigate = useNavigate();
    const [formValues, setFormValues] = useState(defaultFormState);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [companyValues, setCompanyValues] = useState(defaultCompanyState);
    const [companyId, setCompanyId] = useState(null);
    const [companyLoading, setCompanyLoading] = useState(true);
    const [companySaving, setCompanySaving] = useState(false);
    const [activeTab, setActiveTab] = useState("personal-details");
    const [showMenu, setShowMenu] = useState(false);
    const [profilePhotoPreview, setProfilePhotoPreview] = useState("");
    const [profilePhotoUploading, setProfilePhotoUploading] = useState(false);
    const previewUrlRef = useRef(null);
    
    // Gallery state
    const [galleryImages, setGalleryImages] = useState([]);
    const [videos, setVideos] = useState([]);
    const [newVideoUrl, setNewVideoUrl] = useState("");
    const [galleryUploading, setGalleryUploading] = useState(false);
    const [galleryId, setGalleryId] = useState(null);
    
    // Default location state
    const [selectedCountry, setSelectedCountry] = useState('india');
    const [searchAddress, setSearchAddress] = useState('');
    const [mapCenter, setMapCenter] = useState({ lat: 20.5937, lng: 78.9629 }); // Default to India

    useEffect(() => {
        return () => {
            if (previewUrlRef.current) {
                URL.revokeObjectURL(previewUrlRef.current);
            }
        };
    }, []);

    const extractRows = (response) => {
        if (!response?.success) {
            return [];
        }
        if (Array.isArray(response?.data)) {
            return response.data;
        }
        if (Array.isArray(response?.data?.items)) {
            return response.data.items;
        }
        return [];
    };

    const parseMeta = (metaValue) => {
        if (!metaValue) {
            return {};
        }
        if (typeof metaValue === "object") {
            return metaValue || {};
        }
        try {
            return JSON.parse(metaValue);
        } catch (error) {
            console.warn("Unable to parse company meta", error);
            return {};
        }
    };

    const generateCompanyCode = () => {
        const random = Math.random().toString(36).substr(2, 4).toUpperCase();
        const timestamp = Date.now().toString().slice(-4);
        return `INS-${random}${timestamp}`;
    };

    const trimValue = (value) => {
        if (typeof value === "string") {
            return value.trim();
        }
        if (value === null || value === undefined) {
            return "";
        }
        return String(value).trim();
    };

    const releasePreviewUrl = () => {
        if (previewUrlRef.current) {
            URL.revokeObjectURL(previewUrlRef.current);
            previewUrlRef.current = null;
        }
    };

    const isInsuranceUser = (userData?.user_type || "").toLowerCase() === "insurance";

    // Tab to URL mapping
    const tabToUrlMapping = {
        "personal-details": "personal-details",
        "company-profile": "company-profile",
        "gallery": "gallery",
        "default-location": "default-location",
    };

    // URL to tab mapping
    const urlToTabMapping = {
        "personal-details": "personal-details",
        "company-profile": "company-profile",
        "gallery": "gallery",
        "default-location": "default-location",
    };

    useEffect(() => {
        if (sublink) {
            setActiveTab(urlToTabMapping[sublink] || "personal-details");
        } else {
            setActiveTab("personal-details");
            navigate("/insurance/profile/personal-details", { replace: true });
        }
    }, [sublink, navigate]);

    useEffect(() => {
        fetchProfile();
        fetchGallery();
        fetchDefaultLocation();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userData?.id]);

    useEffect(() => {
        if (userData?.user_type?.toLowerCase() === "insurance" || userData?.company_id) {
            fetchCompanyDetails();
        } else {
            setCompanyLoading(false);
            setCompanyValues(defaultCompanyState);
            setCompanyId(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userData?.id, userData?.company_id, userData?.user_type]);

    const fetchProfile = async () => {
        if (!userData?.id) {
            setLoading(false);
            return;
        }

        try {
            setLoading(true);
            const response = await oneKlicks.read(
                "",
                "users",
                { id: userData.id },
                "id ASC",
                "",
                "",
                ""
            );

            if (response?.success && response?.data?.length) {
                const profile = response.data[0];
                // Parse languages if stored as JSON string
                let languagesArray = [];
                if (profile.languages) {
                    try {
                        languagesArray = typeof profile.languages === 'string' 
                            ? JSON.parse(profile.languages) 
                            : Array.isArray(profile.languages) 
                                ? profile.languages 
                                : [];
                    } catch (e) {
                        languagesArray = [];
                    }
                }
                setFormValues({
                    gendar: profile.gendar || "",
                    subheading: profile.subheading || "",
                    display_name: profile.display_name || "",
                    first_name: profile.first_name || "",
                    last_name: profile.last_name || "",
                    email: profile.email || "",
                    phone: profile.phone || "",
                    mobile_number: profile.mobile_number || "",
                    description: profile.description || "",
                    languages: languagesArray,
                    address: profile.address || "",
                    city: profile.city || "",
                    state: profile.state || "",
                    country: profile.country || "",
                    postal_code: profile.postal_code || "",
                    profile_photo_url: profile.profile_photo_url || "",
                });
            } else {
                setFormValues(defaultFormState);
            }
            releasePreviewUrl();
            setProfilePhotoPreview("");
        } catch (error) {
            console.error("Error loading profile:", error);
            toast.error("Unable to load profile details");
            setFormValues(defaultFormState);
            releasePreviewUrl();
            setProfilePhotoPreview("");
        } finally {
            setLoading(false);
        }
    };

    const fetchCompanyDetails = async () => {
        if (!userData?.id) {
            setCompanyLoading(false);
            setCompanyValues(defaultCompanyState);
            setCompanyId(null);
            return;
        }

        try {
            setCompanyLoading(true);
            let companyRecord = null;

            if (userData?.company_id) {
                const scopedResponse = await oneKlicks.read(
                    "",
                    "insurance_companies",
                    { id: Number(userData.company_id) },
                    "id DESC",
                    "",
                    "",
                    ""
                );
                const scopedRows = extractRows(scopedResponse);
                if (scopedRows.length > 0) {
                    companyRecord = scopedRows[0];
                }
            }

            if (!companyRecord) {
                const fallbackResponse = await oneKlicks.read(
                    "",
                    "insurance_companies",
                    {},
                    "id DESC",
                    "",
                    "",
                    "0,100"
                );
                const fallbackRows = extractRows(fallbackResponse);
                companyRecord = fallbackRows.find((row) => {
                    const createdBy = Number(row.created_by || row.user_id || row.owner_id || row.createdBy);
                    if (createdBy && Number(userData?.id) === createdBy) {
                        return true;
                    }
                    const meta = parseMeta(row.meta);
                    return Number(meta?.created_by) === Number(userData?.id);
                }) || null;
            }

            if (companyRecord) {
                const meta = parseMeta(companyRecord.meta);
                setCompanyId(companyRecord.id || null);
                setCompanyValues({
                    company_name: companyRecord.company_name || companyRecord.name || "",
                    legal_name: companyRecord.legal_name || "",
                    email: companyRecord.company_email || companyRecord.email || "",
                    phone: companyRecord.company_phone || companyRecord.phone || "",
                    support_email: meta.support_email || "",
                    support_phone: meta.support_phone || "",
                    website: meta.website || "",
                    registration_number: companyRecord.registration_number || "",
                    license_number: companyRecord.license_number || "",
                    gst_number: companyRecord.gst_number || "",
                    address: companyRecord.company_address || companyRecord.address || "",
                    city: companyRecord.company_city || companyRecord.city || "",
                    state: companyRecord.company_state || companyRecord.state || "",
                    country: companyRecord.company_country || companyRecord.country || "",
                    postal_code: companyRecord.company_postal_code || companyRecord.postal_code || "",
                    status: companyRecord.status || "active",
                    notes: meta.notes || "",
                });
            } else {
                setCompanyId(null);
                setCompanyValues(defaultCompanyState);
            }
        } catch (error) {
            console.error("Error loading company profile:", error);
            toast.error("Unable to load company profile");
            setCompanyId(null);
            setCompanyValues(defaultCompanyState);
        } finally {
            setCompanyLoading(false);
        }
    };

    const handleProfilePhotoSelect = async (file) => {
        if (!file) {
            return;
        }

        const validTypes = ["image/jpeg", "image/png", "image/jpg", "image/gif", "image/webp"];
        if (!validTypes.includes(file.type)) {
            toast.error("Upload a valid image file (JPG, PNG, GIF, or WEBP)");
            return;
        }

        const maxSize = 5 * 1024 * 1024; // 5 MB
        if (file.size > maxSize) {
            toast.error("Image size should be 5 MB or less");
            return;
        }

        releasePreviewUrl();
        const previewUrl = URL.createObjectURL(file);
        previewUrlRef.current = previewUrl;
        setProfilePhotoPreview(previewUrl);
        setProfilePhotoUploading(true);

        try {
            const uploadResult = await OneKlicksFileSDK.uploadFile("insurance/profile", "public", file);
            if (!uploadResult?.file?.root || !uploadResult?.file?.fileName) {
                throw new Error(uploadResult?.error || "Upload failed");
            }

            const remoteUrl = `${uploadResult.file.root}/${uploadResult.file.fileName}`;
            setFormValues((prev) => ({ ...prev, profile_photo_url: remoteUrl }));
            toast.success("Profile photo updated");

            releasePreviewUrl();
            setProfilePhotoPreview("");
        } catch (error) {
            console.error("Error uploading profile photo:", error);
            toast.error("Failed to upload profile photo");
            releasePreviewUrl();
            setProfilePhotoPreview("");
        } finally {
            setProfilePhotoUploading(false);
        }
    };

    const handleProfilePhotoRemove = () => {
        releasePreviewUrl();
        setProfilePhotoPreview("");
        setFormValues((prev) => ({ ...prev, profile_photo_url: "" }));
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormValues((prev) => ({ ...prev, [name]: value }));
    };

    const handleCompanyInputChange = (event) => {
        const { name, value } = event.target;
        setCompanyValues((prev) => ({ ...prev, [name]: value }));
    };

    const handleTabClick = (tabKey) => {
        setActiveTab(tabKey);
        const urlPath = tabToUrlMapping[tabKey];
        if (urlPath) {
            navigate(`/insurance/profile/${urlPath}`);
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!userData?.id) {
            toast.error("Unable to update profile. Missing user information.");
            return;
        }

        if (profilePhotoUploading) {
            toast.info("Profile photo is uploading. Please wait and try again.");
            return;
        }

        try {
            setSaving(true);
            // Handle languages array - convert to JSON string if array
            let languagesValue = null;
            if (formValues.languages && Array.isArray(formValues.languages) && formValues.languages.length > 0) {
                languagesValue = JSON.stringify(formValues.languages);
            }
            
            const payload = {
                gendar: trimValue(formValues.gendar) || null,
                subheading: trimValue(formValues.subheading) || null,
                display_name: trimValue(formValues.display_name) || null,
                first_name: trimValue(formValues.first_name) || null,
                last_name: trimValue(formValues.last_name) || null,
                email: trimValue(formValues.email) || null,
                phone: trimValue(formValues.phone) || null,
                mobile_number: trimValue(formValues.mobile_number) || null,
                description: trimValue(formValues.description) || null,
                languages: languagesValue,
                address: trimValue(formValues.address) || null,
                city: trimValue(formValues.city) || null,
                state: trimValue(formValues.state) || null,
                country: trimValue(formValues.country) || null,
                postal_code: trimValue(formValues.postal_code) || null,
                profile_photo_url: trimValue(formValues.profile_photo_url) || null,
            };

            const response = await oneKlicks.update(
                "",
                "users",
                payload,
                { id: userData.id }
            );

            if (response?.success) {
                toast.success("Profile updated successfully");
                fetchProfile();
            } else {
                console.warn("Profile update failed", response);
                toast.error("Failed to update profile. Please try again.");
            }
        } catch (error) {
            console.error("Error updating profile:", error);
            toast.error("An unexpected error occurred while updating your profile");
        } finally {
            setSaving(false);
        }
    };

    const handleCompanySubmit = async (event) => {
        event.preventDefault();

        if (!userData?.id) {
            toast.error("Unable to update company profile. Missing user information.");
            return;
        }

        if (!trimValue(companyValues.company_name)) {
            toast.error("Company name is required");
            return;
        }

        if (!trimValue(companyValues.email)) {
            toast.error("Company email is required");
            return;
        }

        try {
            setCompanySaving(true);
            const timestamp = new Date().toISOString().slice(0, 19).replace("T", " ");
            const registrationNumber = trimValue(companyValues.registration_number) || `REG-${Date.now()}`;
            const licenseNumber = trimValue(companyValues.license_number) || `LIC-${Date.now()}`;
            const gstNumber = trimValue(companyValues.gst_number) || `GST-${Date.now()}`;

            const metaPayload = {
                support_email: trimValue(companyValues.support_email) || null,
                support_phone: trimValue(companyValues.support_phone) || null,
                website: trimValue(companyValues.website) || null,
                notes: trimValue(companyValues.notes) || null,
                created_by: Number(userData.id) || null,
            };

            const basePayload = {
                company_name: trimValue(companyValues.company_name),
                name: trimValue(companyValues.company_name),
                legal_name: trimValue(companyValues.legal_name) || null,
                email: trimValue(companyValues.email),
                company_email: trimValue(companyValues.email),
                phone: trimValue(companyValues.phone) || null,
                company_phone: trimValue(companyValues.phone) || null,
                registration_number: registrationNumber,
                license_number: licenseNumber,
                gst_number: gstNumber,
                address: trimValue(companyValues.address) || null,
                company_address: trimValue(companyValues.address) || null,
                city: trimValue(companyValues.city) || null,
                company_city: trimValue(companyValues.city) || null,
                state: trimValue(companyValues.state) || null,
                company_state: trimValue(companyValues.state) || null,
                country: trimValue(companyValues.country) || null,
                company_country: trimValue(companyValues.country) || null,
                postal_code: trimValue(companyValues.postal_code) || null,
                company_postal_code: trimValue(companyValues.postal_code) || null,
                status: trimValue(companyValues.status) || "active",
                meta: JSON.stringify(metaPayload),
                updated_at: timestamp,
            };

            let response;

            if (companyId) {
                response = await oneKlicks.update(
                    "",
                    "insurance_companies",
                    basePayload,
                    { id: companyId }
                );
            } else {
                const createPayload = {
                    ...basePayload,
                    company_uid: generateCompanyCode(),
                    created_at: timestamp,
                    password: "PLACEHOLDER",
                    password_hash: "PLACEHOLDER",
                    auth_key: "PLACEHOLDER",
                };

                response = await oneKlicks.create("", "insurance_companies", createPayload);

                if (response?.success) {
                    const newCompanyId =
                        response?.data?.insertId ||
                        response?.insertId ||
                        response?.data?.id ||
                        null;

                    if (newCompanyId) {
                        setCompanyId(newCompanyId);
                        await oneKlicks.update("", "users", { company_id: newCompanyId }, { id: userData.id });
                    }
                }
            }

            if (response?.success) {
                toast.success(companyId ? "Company profile updated" : "Company profile saved");
                await fetchCompanyDetails();
            } else {
                toast.error(response?.message || response?.error || "Failed to save company profile");
            }
        } catch (error) {
            console.error("Error saving company profile:", error);
            toast.error("Failed to save company profile");
        } finally {
            setCompanySaving(false);
        }
    };

    const fetchGallery = async () => {
        if (!userData?.id) return;
        
        try {
            const userId = await getuserdata("id");
            const response = await oneKlicks.read(
                "",
                "insurance_gallery",
                { user_id: userId },
                "id DESC",
                "",
                "",
                ""
            );
            
            if (response?.success && response?.data?.length > 0) {
                const gallery = response.data[0];
                setGalleryId(gallery.id);
                setGalleryImages(gallery.images || []);
                setVideos(gallery.videos || []);
            }
        } catch (error) {
            console.error("Error fetching gallery:", error);
        }
    };

    const fetchDefaultLocation = async () => {
        if (!userData?.id) return;
        
        try {
            const userId = await getuserdata("id");
            const response = await oneKlicks.read(
                "",
                "insurance_default_location",
                { user_id: userId },
                "id DESC",
                "",
                "",
                ""
            );
            
            if (response?.success && response?.data?.length > 0) {
                const location = response.data[0];
                setSelectedCountry(location.country || 'india');
                setSearchAddress(location.address || '');
                setMapCenter({ 
                    lat: location.lat || 20.5937, 
                    lng: location.lng || 78.9629 
                });
            }
        } catch (error) {
            console.error("Error fetching default location:", error);
        }
    };

    const handleGallerySubmit = async (e) => {
        e.preventDefault();
        setGalleryUploading(true);
        try {
            const userId = await getuserdata("id");
            const tableSchema = "";
            const tableName = "insurance_gallery";
            const data = {
                user_id: userId,
                images: JSON.stringify(galleryImages),
                videos: JSON.stringify(videos)
            };
            const condition = {
                user_id: userId
            };

            let response;
            if (galleryId) {
                response = await oneKlicks.update(tableSchema, tableName, data, condition);
            } else {
                response = await oneKlicks.create(tableSchema, tableName, data);
                if (response?.success) {
                    const newId = response?.data?.insertId || response?.insertId || response?.data?.id;
                    if (newId) setGalleryId(newId);
                }
            }

            if (response?.success) {
                toast.success("Gallery updated successfully");
                await fetchGallery();
            } else {
                toast.error("Failed to update gallery");
            }
        } catch (error) {
            console.error("Error saving gallery:", error);
            toast.error("Failed to save gallery");
        } finally {
            setGalleryUploading(false);
        }
    };

    const handleDefaultLocationSubmit = async (e) => {
        e.preventDefault();
        try {
            const userId = await getuserdata("id");
            const tableSchema = "";
            const tableName = "insurance_default_location";
            const data = {
                user_id: userId,
                country: selectedCountry,
                address: searchAddress,
                lat: mapCenter.lat,
                lng: mapCenter.lng
            };
            const condition = {
                user_id: userId
            };

            const response = await oneKlicks.update(tableSchema, tableName, data, condition);
            if (!response?.success) {
                // Try creating if update fails
                const createResponse = await oneKlicks.create(tableSchema, tableName, data);
                if (createResponse?.success) {
                    toast.success("Default location saved successfully");
                } else {
                    toast.error("Failed to save default location");
                }
            } else {
                toast.success("Default location updated successfully");
            }
            await fetchDefaultLocation();
        } catch (error) {
            console.error("Error saving default location:", error);
            toast.error("Failed to save default location");
        }
    };

    const getTabTitle = () => {
        if (activeTab === "personal-details") return "Personal Details";
        if (activeTab === "company-profile") return "Company Profile";
        if (activeTab === "gallery") return "Gallery";
        if (activeTab === "default-location") return "Default Location";
        return "Profile Settings";
    };

    return (
        <div className="subbody" style={{ width: "100%", padding: "2% 4%" }}>
            <div className="dc-haslayout dc-dbsectionspace">
                <div className="row">
                    <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-9`}>
                        <form className="dc-user-profile" method="post">
                            <div className="dc-dashboardbox dc-dashboardtabsholder">
                                <DashBordmenu
                                    title="Profile Settings"
                                    status={showMenu}
                                    onClick={() => {
                                        setShowMenu(!showMenu);
                                    }}
                                />
                                <div
                                    className="dc-dashboardboxtitle"
                                    style={{ display: window.innerWidth < 576 ? "none" : "block" }}
                                >
                                    <h2>{getTabTitle()}</h2>
                                </div>

                                <div
                                    className="dc-dashboardtabs"
                                    style={{
                                        display: window.innerWidth < 576 ? (showMenu ? "block" : "none") : "block",
                                    }}
                                >
                                    <ul className="dc-tabstitle nav navbar-nav">
                                        <li className="nav-item">
                                            <a
                                                className={`${activeTab === "personal-details" ? "active" : ""} `}
                                                href="#"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleTabClick("personal-details");
                                                }}
                                            >
                                                Personal Details
                                            </a>
                                        </li>
                                        {isInsuranceUser && (
                                            <li className="nav-item">
                                                <a
                                                    className={`${activeTab === "company-profile" ? "active" : ""} `}
                                                    href="#"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        handleTabClick("company-profile");
                                                    }}
                                                >
                                                    Company Profile
                                                </a>
                                            </li>
                                        )}
                                        <li className="nav-item">
                                            <a
                                                className={`${activeTab === "gallery" ? "active" : ""} `}
                                                href="#"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleTabClick("gallery");
                                                }}
                                            >
                                                Gallery
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a
                                                className={`${activeTab === "default-location" ? "active" : ""} `}
                                                href="#"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleTabClick("default-location");
                                                }}
                                            >
                                                Default location
                                            </a>
                                        </li>
                                    </ul>
                                </div>

                                {activeTab === "personal-details" && (
                                    <PersonalDetails
                                        formValues={formValues}
                                        handleInputChange={handleInputChange}
                                        saving={saving}
                                        loading={loading}
                                        onProfilePhotoSelect={handleProfilePhotoSelect}
                                        onProfilePhotoRemove={handleProfilePhotoRemove}
                                        profilePhotoUploading={profilePhotoUploading}
                                        profilePhotoPreview={profilePhotoPreview}
                                    />
                                )}

                                {activeTab === "company-profile" && isInsuranceUser && (
                                    <div>
                                        <div
                                            className="dc-dashboardboxtitle"
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                padding: "20px 30px 0",
                                            }}
                                        >
                                            <div>
                                                <h3 style={{ margin: 0 }}>Insurance Organization Profile</h3>
                                                <p style={{ margin: "4px 0 0", color: "#6b7280" }}>
                                                    Maintain company level details for policy creation, claims, and
                                                    communications.
                                                </p>
                                            </div>
                                            {companyId && (
                                                <span style={{ fontSize: "13px", color: "#6b7280" }}>
                                                    Company ID: {companyId}
                                                </span>
                                            )}
                                        </div>
                                        <CompanyProfile
                                            companyValues={companyValues}
                                            handleCompanyInputChange={handleCompanyInputChange}
                                            companySaving={companySaving}
                                            companyLoading={companyLoading}
                                            companyId={companyId}
                                        />
                                    </div>
                                )}

                                {activeTab === "gallery" && (
                                    <Gallery 
                                        galleryImages={galleryImages}
                                        setGalleryImages={setGalleryImages}
                                        videos={videos}
                                        setVideos={setVideos}
                                        newVideoUrl={newVideoUrl}
                                        setNewVideoUrl={setNewVideoUrl}
                                        isUploading={galleryUploading}
                                        setIsUploading={setGalleryUploading}
                                        galleryid={galleryId}
                                    />
                                )}

                                {activeTab === "default-location" && (
                                    <Defaultlocation 
                                        selectedCountry={selectedCountry}
                                        setSelectedCountry={setSelectedCountry}
                                        searchAddress={searchAddress}
                                        setSearchAddress={setSearchAddress}
                                        mapCenter={mapCenter}
                                        setMapCenter={setMapCenter}
                                        userdata={userData}
                                    />
                                )}
                            </div>
                            <div className="dc-updatall">
                                <i className="ti-announcement"></i>
                                <span>
                                    Update all the latest changes made by you, by just clicking on Save &amp; Update
                                    button.
                                </span>
                                <a
                                    className="dc-btn dc-update-profile-doctorss"
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        if (profilePhotoUploading) {
                                            toast.info("Profile photo is uploading. Please wait.");
                                            return;
                                        }
                                        if (activeTab === "personal-details") {
                                            handleSubmit(e);
                                        } else if (activeTab === "company-profile") {
                                            handleCompanySubmit(e);
                                        } else if (activeTab === "gallery") {
                                            handleGallerySubmit(e);
                                        } else if (activeTab === "default-location") {
                                            handleDefaultLocationSubmit(e);
                                        }
                                    }}
                                >
                                    Save &amp; Update
                                </a>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InsuranceProfileSettings;

